import React, { useState } from 'react';

import RequestService from "../../services/request.service";

import AuthService from '../../features/auth/auth.service'

import { Form, Button, Modal } from 'react-bootstrap';

import { toast } from 'react-toastify'

import moment from 'moment'


import { Formik } from 'formik';
import * as yup from 'yup';



import Dialog from '../../services/Dialogs'


const ModalReporteServicioIncumplido = ( params : any ) => {

  const user = AuthService.getCurrentUser()

  const { show, handleClose, tarea } = params


  const dialog = new Dialog();


  const mensajes_validacion_generico = "Este campo es obligatorio"
  const schema = yup.object().shape({
          detalles_atencion : yup.string().required(mensajes_validacion_generico),
  });


  const [ envio_server, setSeEnvio ] = useState<boolean>(false)


  const enviarFormulario = async (registro:any,event:any) =>{
        await dialog.open({
          accept: 'Si',
          cancel: 'Espera',
          dialogClass: '',
          message: '¿Estás seguro de la información?',
          target: event.target,
          template: ''
        })
        let dialogo : any = await dialog.waitForUser()
        if(dialogo){
          try{

          setSeEnvio(true)
          let res_ = await RequestService.update( `tecnicos/registro_actividad_incumplida/${tarea.uuid}` , { ...registro })

          if(res_){
            toast.success('MENSAJE')
            setTimeout(()=>{
              handleClose()
            },0)
          }
          else{
            toast.error('Problemas...')
          } 
          }
          catch(e:any){
            toast.error(e.response.data)
            // console.log(e.response.data)
          } 
          
        }
       
  }





  return (
    <>
      <Modal show={show} onHide={handleClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Reportar Tarea</Modal.Title>
        </Modal.Header>
        <Modal.Body>

            <small>Boutique</small>
            <h3>{ tarea.idboutique.nombre_boutique }</h3>


          <div className="row">
            <div className="col-sm-6">
              <small>Folio</small>
              <h6>{tarea.folio}</h6>
            </div>
            <div className="col-sm-6">
                <small>Fecha</small>
                <h6>{moment(tarea.fecha_programada).format('DD [de] MMMM [de] YYYY').toUpperCase()}</h6>
            </div>
          </div>

<div className={`estatus_atencion_${tarea.idestatus_atencion.id} 
            mt-2 text-center p-2`}>
  <h5 className="nm" style={{color:'white'}}>{tarea.idestatus_atencion.estatus}</h5>
</div>



    <Formik
      validationSchema={schema}
      onSubmit={(values,e)=>{enviarFormulario(values, e)}}
      initialValues={{

            detalles_atencion : "",

      }}
    >
      {({
        handleSubmit,
        handleChange,
        setFieldValue,
        handleBlur,
        values,
        touched,
        isValid,
        errors,
      }) => (
        <Form id='my-form' noValidate onSubmit={handleSubmit}>


            <Form.Group className="mt-3" controlId="detalles_atencion">
              <Form.Label>Explica las circunstancia</Form.Label>
              <Form.Control
                as="textarea"
                required
                name="detalles_atencion"
                value={values.detalles_atencion}
                onChange={(e)=>{ setFieldValue('detalles_atencion', (e.target.value || "").toUpperCase() ) }}
                isInvalid={!!errors.detalles_atencion}
              />
              <Form.Control.Feedback type="invalid"> {<>{errors.detalles_atencion}</>} </Form.Control.Feedback>
            </Form.Group>



        </Form>
      )}
    </Formik>


          {
            // JSON.stringify(tarea)
          }
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button variant="success" form='my-form' type="submit">Guardar <i className="fa fa-save"/></Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}


export default ModalReporteServicioIncumplido;